module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.isHcpView) ? _c('mu-paper', {
    staticClass: "nav bottom"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "horizontalScroll",
    staticStyle: {
      "white-space": "nowrap",
      "padding": "0"
    }
  }, [_vm._l((_vm.filterTypes), function(item, index) {
    return _c('li', {
      key: 'filter-' + index,
      class: {
        isActive: item.type === _vm.query.type
      },
      on: {
        "click": function($event) {
          return _vm.setFilter(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n          "), (item.type === 'MY_ANSWERS') ? _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "color": "white"
      }
    }, [_c('mu-badge', {
      attrs: {
        "primary": "",
        "content": _vm.userAnswers
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type === 'MY_QUESTIONS') ? _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "color": "white"
      }
    }, [_c('mu-badge', {
      attrs: {
        "primary": "",
        "content": _vm.userQuestions
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.categories), function(item, index) {
    return (item.count > 0) ? _c('li', {
      class: {
        isActive: item.id === _vm.query.category
      },
      attrs: {
        "index": 'category-' + item.id
      },
      on: {
        "click": function($event) {
          return _vm.setCategory(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n          "), _c('span', {
      staticStyle: {
        "margin-left": "8px",
        "color": "white"
      }
    }, [_c('mu-badge', {
      attrs: {
        "primary": "",
        "content": item.count
      }
    })], 1)]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "bottom",
    attrs: {
      "desktop": "70",
      "tablet": "60",
      "width": "100"
    }
  }, [(_vm.query.type === 'SEARCH') ? _c('mu-card', [_c('mu-card-text', [_c('div', [_vm._v("Search term: "), _c('strong', [_vm._v(_vm._s(_vm.query.q))])]), _vm._v(" "), (!_vm.isLoading) ? _c('div', [(_vm.data.total_questions > _vm.query.per_page) ? _c('span', [_vm._v(" Showing "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.query.per_page)
    }
  }), _vm._v(" of ")]) : _vm._e(), _vm._v(" "), _c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.data.total_questions)
    }
  }), _vm._v(" results\n          ")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('mu-card', [_c('div', [_c('mu-list', [(_vm.isLoading) ? _c('div', _vm._l((_vm.dummyLoaders), function(item, index) {
    return _c('mu-list-item', {
      key: 'dummy-loader-' + index,
      staticClass: "noCursor",
      attrs: {
        "title": item.display_name
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "width": "50%",
        "height": "14px",
        "background": "rgb(214, 214, 214)",
        "margin-bottom": "8px"
      },
      style: ({
        width: _vm.getRandomArbitrary(40, 50)
      }),
      attrs: {
        "slot": "describe",
        "color": "#d9d9d9"
      },
      slot: "describe"
    }), _vm._v(" "), _vm._o(_c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.image,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }), 0, 'dummy-loader-' + index), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "12px",
        "width": "15%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1)], 1)
  }), 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.questions), function(question, index) {
    return (!_vm.isLoading) ? _c('mu-list-item', {
      key: 'question-' + index,
      staticClass: "questionItem",
      class: {
        isHidden: _vm.isAuthAdmin && question.hidden
      },
      attrs: {
        "disableRipple": ""
      }
    }, [(!question.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "color": "#0179d5",
        "backgroundColor": "#E9E9E8"
      },
      slot: "left"
    }, [_vm._v("\n                " + _vm._s(_vm.upperTwoInitials(question.display_name ? question.display_name : question.firstname + ' ' + question.surname)) + "\n              ")]) : _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": question.profile_large,
        "color": "white",
        "backgroundColor": "#E9E9E8"
      },
      on: {
        "click": function($event) {
          return _vm.goToProfile(question.url)
        }
      },
      slot: "left"
    }), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_c('router-link', {
      staticClass: "linkSize",
      attrs: {
        "to": {}
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToQuestion(question.question_id)
        }
      }
    }, [(question.question.length < 200) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.upperCaseFirst(question.question)))
      }
    }) : _vm._e(), _vm._v(" "), (question.question.length > 200) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(("$sanitize(" + (question.question.substr(0, 200)) + "...)"))
      }
    }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('div', {
      staticClass: "asked-by"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.$t('message.discussionAskedBySuffix'))
      }
    }), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/profile/' + question.url
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(question.display_name)
      }
    })]), _vm._v("\n                  " + _vm._s(_vm.$t('message.discussionAskedAtSuffix'))), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(question.timestamp)))])], 1), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [(question.replies > 0) ? _c('span', {
      staticClass: "label-container"
    }, [_c('mu-icon', {
      attrs: {
        "color": "#0179d5",
        "value": "reply",
        "size": 24
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(question.replies + (question.replies > 1 ? (" " + (_vm.$t('message.repliesText'))) : (" " + (_vm.$t('message.replyText'))))))
      }
    })], 1) : _vm._e(), _vm._v(" "), (question.likes > 0) ? _c('span', {
      staticClass: "label-container"
    }, [_c('mu-icon', {
      attrs: {
        "color": "red",
        "size": 24,
        "value": question.liked ? 'favorite' : 'favorite_border'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label",
      domProps: {
        "innerHTML": _vm._s(question.likes + (question.likes > 1 ? (" " + (_vm.$t('message.likesText'))) : (" " + (_vm.$t('message.likeText')))))
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin && question.report_count > 0) ? _c('span', {
      staticClass: "label-container"
    }, [_c('mu-icon', {
      attrs: {
        "size": 24,
        "color": "#E74C3C",
        "value": "report_problem"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label",
      domProps: {
        "innerHTML": _vm._s(question.report_count)
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin && question.hidden) ? _c('span', [_c('mu-icon', {
      attrs: {
        "value": "visibility_off",
        "size": 24
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin && question.hcp == 1) ? _c('span', [_c('mu-icon', {
      attrs: {
        "value": "local_hospital",
        "color": "#8bc34a",
        "size": 24
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "inline-label"
    }, [_vm._v("HCP Question")])], 1) : _vm._e()])]), _vm._v(" "), ((!question.is_admin || _vm.isAuthAdmin) && _vm.$store.state.status.payment.paid) ? _c('mu-icon-menu', {
      attrs: {
        "slot": "right",
        "anchorOrigin": _vm.rightTop,
        "targetOrigin": _vm.rightTop,
        "scroller": _vm.scroller,
        "icon": "more_vert",
        "desktop": ""
      },
      slot: "right"
    }, [(!question.is_admin && !_vm.isAuthAdmin) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "report",
        "title": question.reported ? 'Reported' : 'Report',
        "disabled": question.reported
      },
      on: {
        "click": function($event) {
          return _vm.openReport('THREAD_QUESTION', question.question_id)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": question.hidden === false ? 'visibility_off' : 'visibility',
        "title": question.hidden === false ? _vm.$t('message.hideText') : _vm.$t('message.restoreText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.hideQuestion(question, index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isAuthAdmin) ? _c('mu-menu-item', {
      attrs: {
        "leftIcon": "delete",
        "title": _vm.$t('message.deleteText')
      },
      nativeOn: {
        "click": function($event) {
          return _vm.deleteQuestion(question, index)
        }
      }
    }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  })], 2), _vm._v(" "), (_vm.query.per_page < _vm.data.total_questions || _vm.data.total_questions === 0) ? _c('mu-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.data.total_questions === 0) ? _c('div', {
    staticClass: "errorMessage"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.displayMessage)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.query.per_page < _vm.data.total_questions) ? _c('div', {
    staticClass: "pagination"
  }, [_c('a', {
    staticClass: "mu-pagination-item firstItem",
    on: {
      "click": function($event) {
        return _vm.handlePageChange(1)
      }
    }
  }, [_vm._v("First")]), _vm._v(" "), _c('mu-pagination', {
    attrs: {
      "total": _vm.data.total_questions,
      "current": _vm.data.page,
      "defaultPageSize": 5,
      "pageSize": _vm.query.per_page
    },
    on: {
      "pageChange": _vm.handlePageChange
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "mu-pagination-item lastItem",
    on: {
      "click": function($event) {
        return _vm.handlePageChange(_vm.data.total_questions)
      }
    }
  }, [_vm._v("Last")])], 1) : _vm._e()]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "40",
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('mu-flat-button', {
    staticClass: "askButton",
    attrs: {
      "backgroundColor": "#3d8517",
      "color": "white",
      "label": _vm.isHcpView ? 'New Topic' : _vm.$t('message.discussionButtonAsk')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.askQuestion.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('search-questions', {
    staticClass: "bottom",
    attrs: {
      "isSearching": _vm.isSearching
    }
  }), _vm._v(" "), (!_vm.isHcpView) ? _c('top-contributors', {
    staticClass: "bottom"
  }) : _vm._e(), _vm._v(" "), (!_vm.isHcpView) ? _c('frequently-asked', {
    staticClass: "bottom"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeReport.type && _vm.activeReport.type_id) ? _c('report-modal', {
    attrs: {
      "open": _vm.activeReport.open,
      "type": _vm.activeReport.type,
      "type_id": _vm.activeReport.type_id
    },
    on: {
      "onClose": function($event) {
        _vm.activeReport.open = false
      },
      "onComplete": function($event) {
        return _vm.setReported(_vm.activeReport)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0198d80f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Questions/QuestionsIndex.vue
// module id = 3578
// module chunks = 1